
<script>
import moment from 'moment'
import firebase from '@/firebase'
import _ from 'lodash'

export default {
    name: 'templates',
    firebase: function() { 
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        return {
            allRegistrations: {
                source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid).orderByChild('projectCombined'),
            },
            orgSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
                asObject: true,
            },
            personalSettings: {
                source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid),
                asObject: true,
            }
        }
    },
    methods: {
        useTimeTemplate(week, orgSettings, personalSettings, locale) {
            const self = this;
            const weekInput = week || moment().isoWeek()
            const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
            const userid = JSON.parse(localStorage.getItem('profile')).user_id;
            const ERPenabled = orgSettings.ERPenabled
            const hours = personalSettings.timeTemplate.hours
            const projects = personalSettings.timeTemplate.projects
            const rowDays = personalSettings.timeTemplate.rowDays
            const rowHours  = personalSettings.timeTemplate.rowHours
            moment.locale(locale)
    
            let registrations = [];
            _.forEach(projects, function(project, index) {
                if(project && hours[index]) {
                    const day = moment().isoWeek(weekInput).startOf('isoweek').add(index-1, 'days').format('YYYY-MM-DD')
                    let reg = {
                      project: project.no,
                      projectLine: project.task_no,
                      projectCombined: project.no + '-' + project.task_no,
                      uid: userid,
                      tenantid: tenantid,
                      date: day,
                      time: hours[index],
                      quarter: moment(day).quarter(),
                      isApproved: false,
                      sentForApproval: false,
                      timestamp: moment().format()
                    }
                    if (ERPenabled === false) {
                        reg.isCustomProject = true
                    } 
                    registrations.push(reg)
                }
            })
            let subRegistrations = [];
            _.forEach(rowDays, function(row, index) {
                if(projects[row][index]) {
                    const day = moment().isoWeek(weekInput).startOf('isoweek').add(row-1, 'days').format('YYYY-MM-DD')
                    let reg = {
                      project: projects[row][index].no,
                      projectLine: projects[row][index].task_no,
                      projectCombined: projects[row][index].no + '-' + projects[row][index].task_no,
                      uid: userid,
                      tenantid: tenantid,
                      date: day,
                      time: rowHours[index],
                      quarter: moment(day).quarter(),
                      isApproved: false,
                      sentForApproval: false,
                      timestamp: moment().format()
                    }
                    if (ERPenabled === false) {
                        reg.isCustomProject = true
                    } 
                    subRegistrations.push(reg)
                }
            })
            // // push project registrations to firebase
            // _.forEach(registrations, function(registration) {
            //     self.$firebaseRefs.allRegistrations.push(registration)
            // })
            // // push subproject registrations to firebase
            // _.forEach(subRegistrations, function(registration) {
            //     self.$firebaseRefs.allRegistrations.push(registration)
            // })
            return _.concat(registrations, subRegistrations)
        },
    }
}
</script>